import { useLocation } from "react-router-dom";

import { getActive } from "../components/VerticalMenu/VerticalMenu";

import useDocTitle from "./useDocTitle";

function getActiveText(options, currentPath) {
	const option = options.find(
		({ hidden, path, to, active, options }) =>
			!hidden && getActive({ path: path || to, active, currentPath, options }),
	);

	return option && ((option.options && getActiveText(option.options, currentPath)) || option.name || option.text);
}

export default function useMenuDocTitle(header, options) {
	const { hash, pathname } = useLocation();

	useDocTitle([header, getActiveText(options, pathname + hash)].filter(Boolean).join("/"));
}
